if (!customElements.get('project-details')) {
  class ProjectDetails extends AccordionDetails {
    constructor() {
      super();
    }

    connectedCallback() {
      this.openDefault = this.dataset.openDefault === 'true';

      this.handleOpen();
      document.addEventListener('matchMobile', this.handleOpen.bind(this));
      document.addEventListener('unmatchMobile', this.handleOpen.bind(this));
    }

    handleOpen() {
      this.open = AfcTheme.config.mqlMobile ? this.openDefault : true;
    }

    handleAfterToggle() {
      if (!AfcTheme.config.mqlMobile) {
        return;
      }

      if (this.isOpen) {
        const parent = this.closest('.accordion-parent') || document;
        const siblingsAccordions = parent.querySelectorAll('details[is="project-details"]');

        siblingsAccordions.forEach((details) => {
          if (details !== this) {
            details.open = false;
          }
        });
      }
    }
  }
  customElements.define('project-details', ProjectDetails, { extends: 'details' });
}
